const bodyClassOverlay = document.querySelector('body');

//mobile menu opener start
const mobMenuFirstLvl = document.querySelectorAll(".header-menu-button");
const anoncebar = document.getElementById("announcement-bar");
const headerBlock = document.getElementById("header-holder");
mobMenuFirstLvl.forEach((mobMenuFirstLvlElem) => {
    mobMenuFirstLvlElem.onclick = function (e) {        
      e.preventDefault();
      let mobMenu = document.querySelector('.mobile-menu');
      document.getElementById("trelo-basket").classList.remove('show');
      document.getElementById('header-search').classList.remove("show");
      //bodyClassOverlay.classList.remove("show-overlay");
      bodyClassOverlay.classList.toggle("show-overlay");
      bodyClassOverlay.classList.remove("show-overlay-nh");
      mobMenu.classList.toggle("is-open");
      anoncebar.classList.toggle("hide");
      headerBlock.classList.toggle("hide");
   };
});
//mobile menu opener end

//mobile menu accordion start
const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function (e) {
    e.preventDefault();
    this.classList.toggle("is-open");
    
    let content = this.nextElementSibling;

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});
//mobile menu accordion end

//money format start
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const formatString = format || window.shopMoneyFormat || '{{amount}}';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = formatString.match(placeholderRegex);

  if (!match) {
    return cents;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) {
      return '0';
    }

    thousands = thousands || ' ';
    decimal = decimal || '.';
    precision = precision ?? 2;

    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  let value = '';
  switch (match[1]) {
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount':
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function formatMoneyWithoutTrailingZeros(price) {
  const cents = Math.round(parseFloat(price) * 100);
  if (isNaN(cents)) {
    return '';
  }

  return formatMoney(cents, window.shopMoneyFormat).replace(/([.,]00)(?!\d)/, '');
}
//money format end

//search fast result start
const searchBlock = document.getElementById('header-search');
const searchForm = document.getElementById('header-search__form');
const searchInput = document.getElementById('header-search__form-input');
const searchResults = document.getElementById('header-search__result-list');
const searchResultsTop = document.getElementById('header-search__result-top');
const searchResultsTopLink = document.getElementById('header-search__result-top-link');
const searchResultsEmpty = document.getElementById('header-search__result-list-empty');
const toolprdidSearch = searchResults.dataset.toolprdidsearch;
const saleCollectionHandle = 'sale';

// Event listener for user input in the search form
searchInput.addEventListener('input', function () {
  const query = searchInput.value.trim();
  const discountenable = searchInput.dataset.discountenable;
  const discountnumber = searchInput.dataset.discountnumber;
  productHeaderSearch(query,discountenable,discountnumber);
});

function productHeaderSearch(query,discountenable,discountnumber) {
  var searchCountItem = 1;

  // If the search query is not empty, send a request to Shopify API
  if (query !== '') {
  
    fetch(`/search/suggest.json?q=${query}&type=product&options[unavailable_products]=hide`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        // Process and display the search results
        if (data && data.resources.results.products.length > 0) {
          // Clear previous search results
          searchResults.innerHTML = '';
          searchResultsEmpty.style.display = "none";
          searchResultsTop.style.display = "block";
          searchResults.style.display = "flex";
          searchResultsTopLink.setAttribute('href', '/search?q='+query+'*&type=product');
          
          let searchHeaderLngt = 0;
          
          if(data.resources.results.products.length == 1){
            data.resources.results.products.forEach(product => {
              if (product.id == toolprdidSearch ) searchHeaderLngt = product.id;
            });
          }           

          data.resources.results.products.forEach(product => {
            if (searchHeaderLngt == 0) {
              if (searchCountItem < 5){
                if (product.id != toolprdidSearch ){

                  // Fetch all products in the collection for price start
                  let saleCollectionHandleExist = 0;
                  let productId = product.id;                  
                  fetch(`/collections/${saleCollectionHandle}/products.json`)
                    .then(response => {
                      if (!response.ok) {
                        throw new Error(`Error: ${response.status} ${response.statusText}`);
                      }
                      return response.json();
                    })
                    .then(data => {
                      const products = data.products;
                      // Check if the product ID exists in the collection
                      const productExists = products.some(product => product.id === productId);
                
                      if (productExists) {
                        let saleCollectionHandleExist = 1;
                      } else {
                        let saleCollectionHandleExist = 0;
                      }
                    })
                    .catch(error => console.error('Error fetching collection products:', error));
                  
                  //console.log('saleCollectionHandleExist - '+saleCollectionHandleExist);
                  //console.log(discountenable);
                  //console.log(discountnumber);
                  //console.log(product);
                  // Fetch all products in the collection for price end                  
                  
                  const productLink = document.createElement('a');
                  productLink.setAttribute('class', 'header-search__list-item');
                  productLink.setAttribute('href', product.url);
    
                  const productLinkImage = document.createElement('picture');
                  productLinkImage.setAttribute('class', 'header-search__list-item-img');
    
                  const productLinkImageSource1 = document.createElement('source');
                  productLinkImageSource1.setAttribute('media', '(min-width:2500px)');
                  productLinkImageSource1.setAttribute('srcset', product.featured_image.url+'&width=2560');
    
                  const productLinkImageSource2 = document.createElement('source');
                  productLinkImageSource2.setAttribute('media', '(min-width:1900px)');
                  productLinkImageSource2.setAttribute('srcset', product.featured_image.url+'&width=1900');
    
                  const productLinkImageSource3 = document.createElement('source');
                  productLinkImageSource3.setAttribute('media', '(min-width:1400px)');
                  productLinkImageSource3.setAttribute('srcset', product.featured_image.url+'&width=1400');
    
                  const productLinkImageSource4 = document.createElement('source');
                  productLinkImageSource4.setAttribute('media', '(min-width:1200px)');
                  productLinkImageSource4.setAttribute('srcset', product.featured_image.url+'&width=1200');
    
                  const productLinkImageSource5 = document.createElement('source');
                  productLinkImageSource5.setAttribute('media', '(min-width:900px)');
                  productLinkImageSource5.setAttribute('srcset', product.featured_image.url+'&width=900');
    
                  const productLinkImageSource6 = document.createElement('source');
                  productLinkImageSource6.setAttribute('media', '(min-width:800px)');
                  productLinkImageSource6.setAttribute('srcset', product.featured_image.url+'&width=800');
    
                  const productLinkImageSource7 = document.createElement('source');
                  productLinkImageSource7.setAttribute('media', '(min-width:400px)');
                  productLinkImageSource7.setAttribute('srcset', product.featured_image.url+'&width=800');
    
                  const productLinkImageSource8 = document.createElement('source');
                  productLinkImageSource8.setAttribute('media', '(min-width:300px)');
                  productLinkImageSource8.setAttribute('srcset', product.featured_image.url+'&width=600');
    
                  const productLinkImageImg = document.createElement('img');
                  productLinkImageImg.setAttribute('src', product.featured_image.url+'&width=600');
                  productLinkImageImg.setAttribute('width', product.featured_image.width);
                  productLinkImageImg.setAttribute('height', product.featured_image.height);
                  productLinkImageImg.setAttribute('loading', 'lazy');
                  productLinkImageImg.setAttribute('alt', product.featured_image.alt);
    
                  const productLinkText = document.createElement('div');
                  productLinkText.setAttribute('class', 'header-search__list-item-text');
    
                  const productLinkTitle = document.createElement('div');
                  productLinkTitle.setAttribute('class', 'header-search__list-item-title');
                  productLinkTitle.textContent = product.title;

                  const productLinkPrice = document.createElement('div');
                  const productPrice = parseFloat(product.price);
                  const compareAtPrice = parseFloat(product.compare_at_price_max);
                  const hasComparePrice = compareAtPrice > productPrice;

                  if (saleCollectionHandleExist == 1) {
                    if (hasComparePrice) {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');
                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = formatMoneyWithoutTrailingZeros(product.price);
                      productLinkPrice.appendChild(productLinkPriceNEW);
                      const productLinkPriceOld = document.createElement('span');
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = formatMoneyWithoutTrailingZeros(product.compare_at_price_max);
                      productLinkPrice.appendChild(productLinkPriceOld);
                    } else {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price');
                      productLinkPrice.textContent = formatMoneyWithoutTrailingZeros(product.price);
                    }
                  } else if (discountenable == 1) {
                      const newPrice = productPrice * parseFloat(discountnumber);

                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');

                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = formatMoneyWithoutTrailingZeros(newPrice);
                      productLinkPrice.appendChild(productLinkPriceNEW);

                      const productLinkPriceOld = document.createElement('span');
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = formatMoneyWithoutTrailingZeros(product.price);
                      productLinkPrice.appendChild(productLinkPriceOld);
                  } else {
                    if (hasComparePrice) {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');
                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = formatMoneyWithoutTrailingZeros(product.price);
                      productLinkPrice.appendChild(productLinkPriceNEW);
                      const productLinkPriceOld = document.createElement('span');
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = formatMoneyWithoutTrailingZeros(product.compare_at_price_max);
                      productLinkPrice.appendChild(productLinkPriceOld);
                    } else {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price');
                      productLinkPrice.textContent = formatMoneyWithoutTrailingZeros(product.price);
                    }
                  }
   
                  productLinkImage.appendChild(productLinkImageSource1);
                  productLinkImage.appendChild(productLinkImageSource2);
                  productLinkImage.appendChild(productLinkImageSource3);
                  productLinkImage.appendChild(productLinkImageSource4);
                  productLinkImage.appendChild(productLinkImageSource5);
                  productLinkImage.appendChild(productLinkImageSource6);
                  productLinkImage.appendChild(productLinkImageSource7);
                  productLinkImage.appendChild(productLinkImageSource8);
                  productLinkImage.appendChild(productLinkImageImg);
    
                  productLinkText.appendChild(productLinkTitle);
                  productLinkText.appendChild(productLinkPrice);
    
                  productLink.appendChild(productLinkImage);
                  productLink.appendChild(productLinkText);
                  
                  searchResults.appendChild(productLink);
                  searchCountItem++;
                  searchBlock.classList.add("searchBlock-height");
                }
              }
            } else {
              // Clear previous search results
              searchResults.innerHTML = '';
              // Display a message for no results
              searchResultsTop.style.display = "none";
              searchResults.style.display = "none";
              searchResultsEmpty.style.display = "block";
              searchBlock.classList.remove("searchBlock-height");
            }
          });
        } else {
          // Clear previous search results
          searchResults.innerHTML = '';
          // Display a message for no results
          searchResultsTop.style.display = "none";
          searchResults.style.display = "none";
          searchResultsEmpty.style.display = "block";
          searchBlock.classList.remove("searchBlock-height");
        }
      })
      .catch(error => {
        console.error('Error fetching search results:', error);
      });      
  } else {
    searchResults.innerHTML = '';
    searchResultsTop.style.display = "none";
    searchResults.style.display = "none";
    searchResultsEmpty.style.display = "block";
    searchBlock.classList.remove("searchBlock-height");
  }
}
//search fast result end

//cart drawer recommendations start
window.renderDrawerRecommendations = function() {
  const container = document.getElementById('trelo-basket-drawer__recomended-list');
  if (!container) return;

  const productId = container.dataset.productId;
  const sectionId = container.dataset.sectionId;
  const limit = container.dataset.limit || '4';
  const recommendationsBlock = document.getElementById('trelo-basket-drawer__recomended');

  if (!productId || !sectionId) {
    container.innerHTML = '';
    if (recommendationsBlock) recommendationsBlock.style.display = 'none';
    return;
  }

  const url = `${market_handle}/recommendations/products?product_id=${productId}&limit=${limit}&intent=complementary&section_id=${sectionId}`;
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const section = wrapper.querySelector(`#shopify-section-${sectionId}`);
      const content = section ? section.innerHTML.trim() : html.trim();
      container.innerHTML = content;

      if (recommendationsBlock) {
        recommendationsBlock.style.display = content.length ? '' : 'none';
      }
    })
    .catch((error) => {
      console.error('Error fetching recommendations:', error);
      container.innerHTML = '';
      if (recommendationsBlock) recommendationsBlock.style.display = 'none';
    });
};

document.addEventListener('DOMContentLoaded', function() {
  window.renderDrawerRecommendations();
});
//cart drawer recommendations end

//basket opener start
var pbasket = document.getElementById("trelo-basket");
const pbasket2 = document.getElementById("trelo-basket-drawer__wrapper");

function hasClass(element, className) {
  return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

function OpenCloseBasket() {  
  document.getElementById("trelo-basket").classList.remove('show');
  document.getElementById('header-search').classList.remove("show");
  document.querySelector('.mobile-menu').classList.remove("is-open");
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.add("show-overlay");
  bodyClassOverlay.classList.remove("show-overlay-nh");
  pbasket.classList.toggle("show");
  //anoncebar.classList.toggle("hide");
  //headerBlock.classList.toggle("hide");
}

function CloseBasket() {
  document.querySelector('.mobile-menu').classList.remove("is-open");
  document.getElementById('header-search').classList.remove("show");
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.remove("show-overlay-nh");
  pbasket.classList.remove('show');
  anoncebar.classList.remove("hide");
  headerBlock.classList.remove("hide");
}
//basket opener end

//search opener start
function showHeaderSearch() {
  const headerSearchShow = document.getElementById('header-search');
  document.querySelector('.mobile-menu').classList.remove("is-open");
  document.getElementById("trelo-basket").classList.remove('show');
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.toggle("show-overlay-nh");
  headerSearchShow.classList.toggle("show");
}
//search opener end
//close all popup start
function closeAllPopup() {
  document.querySelector('.mobile-menu').classList.remove("is-open");
  document.getElementById("trelo-basket").classList.remove('show');
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.remove("show-overlay-nh");
  document.getElementById('header-search').classList.remove("show");
}
//close all popup end

//mobile click overlay start
const overlayClose = document.getElementById("popup-overlay");

overlayClose.addEventListener("click", (e) => {
  e.preventDefault();
  let mobMenu = document.querySelector('.mobile-menu');
  document.getElementById("trelo-basket").classList.remove('show');
  document.getElementById('header-search').classList.remove("show");
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.remove("show-overlay-nh");
  mobMenu.classList.remove("is-open");
  anoncebar.classList.remove("hide");
  headerBlock.classList.remove("hide");
});


const overlayCloseNh = document.getElementById("popup-overlay-nh");

overlayCloseNh.addEventListener("click", (e) => {
  e.preventDefault();
  let mobMenu = document.querySelector('.mobile-menu');
  document.getElementById("trelo-basket").classList.remove('show');
  document.getElementById('header-search').classList.remove("show");
  bodyClassOverlay.classList.remove("show-overlay");
  bodyClassOverlay.classList.remove("show-overlay-nh");
  mobMenu.classList.remove("is-open");
  anoncebar.classList.remove("hide");
  headerBlock.classList.remove("hide");
});
//mobile click overlay end


//fixed header start
window.addEventListener('scroll', function() {
    const header = document.querySelector('.header-holder');
    const body = document.querySelector('body');
    const announcement = document.querySelector('.announcement-bar').offsetHeight;
    
    if (window.scrollY > announcement) {
        header.classList.add('fixed');
        body.classList.add('headerfixed');
    } else {
        header.classList.remove('fixed');
        body.classList.remove('headerfixed');
    }
});
//fixed header end

//footer menu accordion start
const accordionBtnsF = document.querySelectorAll(".accordion-footer");

accordionBtnsF.forEach((accordionF) => {
  accordionF.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});
//footer menu accordion end

//PRODUCT ADD/REMOVE TO CART JS START
//insert to THML dom
function setInnerHTML(elm, html) {
  elm.innerHTML = html;

  Array.from(elm.querySelectorAll('script')).forEach((oldScriptEl) => {
    const newScriptEl = document.createElement('script');

    Array.from(oldScriptEl.attributes).forEach((attr) => {
      newScriptEl.setAttribute(attr.name, attr.value);
    });

    const scriptText = document.createTextNode(oldScriptEl.innerHTML);
    newScriptEl.appendChild(scriptText);

    oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  });
}
//insert to THML dom end

//section rendering
window.renderCart = function () {
  fetch(`${market_handle}/?sections=${document.getElementById('trelo-basket').getAttribute('section-id')}`)
    .then((response) => response.json())
    .then((json) => {
      let html = json[document.getElementById('trelo-basket').getAttribute('section-id')];
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');
      let newCheckout = doc.getElementById('trelo-basket-drawer__wrapper');
      let newCheckoutHtml = newCheckout.outerHTML;
      setInnerHTML(document.getElementById('trelo-basket-drawer__block'), newCheckoutHtml);
      let prodCountAfterEvent = document.getElementById('prodCountAfterEvent').getAttribute('prodCountAfterEvent');
      setInnerHTML(document.getElementById('header-right-link-item-basket-cnt'), prodCountAfterEvent);
      setInnerHTML(document.getElementById('header-right-link-item-basket-cnt2'), prodCountAfterEvent);
      prodCountAfterEvent = parseInt(prodCountAfterEvent);
      if (prodCountAfterEvent > 0) {
        document.getElementById('header-right-link-item-basket-cnt').style.display = "flex"
        document.getElementById('header-right-link-item-basket-cnt2').style.display = "flex"
      } else {
        document.getElementById('header-right-link-item-basket-cnt').style.display = "none"
        document.getElementById('header-right-link-item-basket-cnt2').style.display = "none"
      }

      window.renderDrawerRecommendations();
    })
    .catch((error) => {
      // Handle errors
      console.error('Error rendering section:', error);
    });  
};
//section rendering end

// Remove and Update item start
function removeItem(variantId, variantQuantity, outOfStuck) {
  if (outOfStuck >= variantQuantity) {
    variantQuantity = variantQuantity;
  } else {
    variantQuantity = 0;
  }   

  fetch(`${market_handle}/cart/change.js?id=${variantId}&quantity=${variantQuantity}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // For Shopify AJAX API
      },
    })
    .then(response => response.json())
    .then(data => {
      // Update the cart quantity display
      window.renderCart();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
}

function removeItem2(variantId, variantQuantity, outOfStuck) {
  if (outOfStuck >= variantQuantity) {
    variantQuantity = variantQuantity;
  } else {
    variantQuantity = 0;
  }   

  fetch(`${market_handle}/cart/change.js?id=${variantId}&quantity=${variantQuantity}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // For Shopify AJAX API
      },
    })
    .then(response => response.json())
    .then(data => {      
      // Update the cart quantity display
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
}
// Remove and Update item end

// Remove and Update item engraving start
function removeItemEngr(variantId, variantQuantity, outOfStuck, variantIdEngr, variantIdEngrQuantity) {
  if (outOfStuck >= variantQuantity) {
    variantQuantity = variantQuantity;
  } else {
    variantQuantity = 0;
  }   
    
  fetch(`${market_handle}/cart/change.js?id=${variantId}&quantity=${variantQuantity}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', // For Shopify AJAX API
    },
  })
  .then(response => response.json())
  .then(data => {
    // Update the cart quantity display
    
    fetch(`${market_handle}/cart/change.js?id=${variantIdEngr}&quantity=${variantIdEngrQuantity}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // For Shopify AJAX API
      },
    })
    .then(response => response.json())
    .then(data => {
      // Update the cart quantity display
      window.renderCart();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });

    
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });    
}
// Remove and Update item engraving end

// Add item
function addItem(variantId, variantQuantity) {
  fetch(market_handle+'/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: variantQuantity,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log('Success:', data);
      window.renderCart();      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
// Add item End

//recomended start
function addRecomendedProduct(variantId, variantQuantity) {
  addItem(variantId, variantQuantity);
  setTimeout(() => {
    document.getElementById("trelo-basket-drawer__recomended").style.display = "none";
  }, "1000");  
}
//recomended end
//PRODUCT ADD/REMOVE TO CART JS END

/*localization menu start*/
document.addEventListener('DOMContentLoaded', function() {
  var selectElement = document.getElementById('localization-selector');
  var formElement = document.getElementById('Headerlocalization');

  selectElement.addEventListener('change', function() {
    formElement.submit();
  });
});
/*localization menu end*/

/*add to cart form submit on collection start*/
document.addEventListener('DOMContentLoaded', function() {
  const prodFormSubmitCol = document.querySelectorAll('.grid-product__item-form');
  
  prodFormSubmitCol.forEach((prodFormSubmitColElem) => {
    prodFormSubmitColElem.addEventListener("submit", (event) => {
      var formData = new FormData(prodFormSubmitColElem);
      var quantityValue = formData.get('quantity');
      var quantity = parseInt(quantityValue, 10);
      const errorElement = prodFormSubmitColElem.querySelector('.grid-product__item-form-error');
      
      if (!isNaN(quantity) && quantity >= 1) {
        console.log("Quantity is valid:", quantity);
        errorElement.classList.add('visually-hidden');
          
        fetch(market_handle+'/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => {
          if (response.ok) {                        
              setTimeout(() => {
                window.renderCart();
                OpenCloseBasket();
              }, "1000");
              //console.log('Product added to cart successfully');
              // Optionally, you can update the cart preview or display a success message
          } else {
              console.error('Failed to add product to cart');
          }
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        });
      } else {
        console.log("Invalid quantity entered.");
        errorElement.classList.remove('visually-hidden');
      }
      event.preventDefault();
    });
  });
});

function cpqtyMinus(e) {  
  let content = e.nextElementSibling;  
  let curQty = parseInt(content.value);
  if (curQty >= 2) {
    curQty = curQty - 1;
    console.log('content.value B - ' + curQty);
  } else {
    console.log('content.value S - ' + curQty);
    curQty = 1;
  }
  content.value = curQty;     
}
function cpqtyPlus(e) {  
  let content = e.previousElementSibling;  
  let curQty = parseInt(content.value);
  curQty = curQty + 1;
  content.value = curQty;
  console.log('content.value S - ' + curQty);
  
       
}

/*add to cart form submit on collection end*/